module.exports = __webpack_public_path__ + "fonts/righthand-lightitalicdash-personal.d0541f83.ttf";